import {RootState} from "../../../../../app/store";
import {
    BotFormSelectionProvider,
    BotRequestPartial
} from "../createAndUpdate/BotForm";
import {
    BotType,
    Country,
    CreateBotRequestOpenAiModelEnum,
    LocaleTag,
    MatchField,
    MatchType,
    RedirectProvider,
    SupportedTimezone
} from "../../../../../api/generated";
import {FranchiseRequestUi} from "../../franchiseTypes";

export const createBotRequestPropertySelector = (rootSelector: (state: RootState) => BotRequestPartial): BotFormSelectionProvider => ({
    publicId(state: RootState): string | undefined {
        return rootSelector(state).publicId;
    },
    siteName(state: RootState): string | undefined {
        return rootSelector(state).siteName;
    },
    siteURL(state: RootState): string | undefined {
        return rootSelector(state).siteURL;
    },
    groupHash(state: RootState): string | undefined {
        return rootSelector(state).groupHash;
    },
    teamInfo(state: RootState): string | undefined {
        return rootSelector(state).teamInfo;
    },
    openAiApiKey(state: RootState): string | undefined {
        return rootSelector(state).openAiApiKey;
    },
    openAiModel(state: RootState): CreateBotRequestOpenAiModelEnum | undefined {
        return rootSelector(state).openAiModel;
    },
    franchiseList(state: RootState): FranchiseRequestUi[] | undefined {
        return rootSelector(state).franchiseList;
    },
    conversationLimit(state: RootState): number | undefined {
        return rootSelector(state).conversationLimit;
    },
    workingRange(state: RootState): number | undefined {
        return rootSelector(state).workingRange;
    },
    lastRenewalDate(state: RootState): string | undefined {
        return rootSelector(state).lastRenewalDate;
    },
    botType(state: RootState): BotType | undefined {
        return rootSelector(state).botType;
    },
    useMultiAgent(state: RootState): boolean | undefined {
        return rootSelector(state).useMultiAgent;
    },
    vehicleProviderWarningEmailEnabled(state: RootState): boolean | undefined {
        return rootSelector(state).vehicleProviderWarningEmailEnabled;
    },
    externalCommunicationsDisabled(state: RootState): boolean | undefined {
        return rootSelector(state).externalCommunicationsDisabled;
    },
    redirectProvider(state: RootState): RedirectProvider | undefined {
        return rootSelector(state).redirectProvider;
    },
    urlProcessorEnabled(state: RootState): boolean | undefined {
        return rootSelector(state).urlProcessorEnabled;
    },
    matchField(state: RootState): MatchField | undefined {
        return rootSelector(state).matchField;
    },
    matchType(state: RootState): MatchType | undefined {
        return rootSelector(state).matchType;
    },
    segmentNumberFromTheEnd(state: RootState): number | undefined {
        return rootSelector(state).segmentNumberFromTheEnd;
    },
    timezone(state: RootState): SupportedTimezone | undefined {
        return rootSelector(state).timezone;
    },
    defaultLocale(state: RootState): LocaleTag | undefined {
        return rootSelector(state).defaultLocale;
    },
    supportedPhoneNumberLocales(state: RootState): Country[] | undefined {
        return rootSelector(state).supportedPhoneNumberLocales;
    },
    assistantEmail(state: RootState): string | undefined {
        return rootSelector(state).assistantEmail;
    },
    assistantEmailPassword(state: RootState): string | undefined {
        return rootSelector(state).assistantEmailPassword;
    },
    emailTranscriptRecipients(state: RootState): string | undefined {
        return rootSelector(state).emailTranscriptRecipients;
    },
    ccRecipients(state: RootState) {
        return rootSelector(state).ccRecipients;
    },
    filtrationEnabled(state: RootState): boolean | undefined {
        return rootSelector(state).filtrationEnabled;
    },
    transcriptSummaryEnabled(state: RootState): boolean | undefined {
        return rootSelector(state).transcriptSummaryEnabled;
    },
    sharingLinkEnabled(state: RootState): boolean | undefined {
        return rootSelector(state).sharingLinkEnabled;
    }
});
